import React from 'react';

const LoadingScreen = ({ loading }) => {
  return (
    <div className={`loading-screen ${!loading ? 'hide' : ''}`}>
      <div className="loader"></div>
      <p style={{ 
        marginTop: '30px', 
        fontFamily: 'Playfair Display, serif', 
        fontSize: '24px',
        color: '#D4AF37',
        letterSpacing: '2px'
      }}>
        SYSTEM
      </p>
    </div>
  );
};

export default LoadingScreen;